
import { Button, createTheme, styled } from '@mui/material';
import { React, useContext, useState } from 'react';
import Form from 'react-bootstrap/Form';

import Modal from 'react-bootstrap/Modal';

import { useNavigate } from 'react-router-dom';

const TextButton = styled(Button)(({ theme }) => ({
  color: 'white',
  textTransform: 'none',
  padding: '0.5vw 0.75vw',
}));

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

export default ({ show, onClose }) => {
  const navigate = useNavigate();

  return (
    <Modal
      style={{ marginTop: '20vh' }}
      show={show}
      dialogClassName="modal-50w"
      aria-labelledby="example-custom-modal-styling-title"
    >

      <Modal.Body style={{ padding: '2vw 2vw', textAlign: 'center', color: 'rgb(0, 15, 30, 0.7)' }}>

        <h4 style={{ textAlign: 'center', fontSize: '1.3vw', marginBottom: '2vw', fontWeight: '500' }}>Session Expired</h4>

        <p style={{ margin: 0, marginBottom: '2.5vw', fontWeight: '300', fontSize: '0.8vw', padding: '0 2vw', color: 'rgb(0, 15, 30, 0.7)' }}>Your session has expired please sign in again</p>

        <div>

          <Button
            onClick={async () => {
              navigate('/setting?tab=AccountingSoftwareSettings');
              onClose();
            }}
            variant="outlined"
            style={{
              borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '0vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
              width: '100%', marginTop: '1vw' }}
          >
            Sign In
          </Button>
        </div>

      </Modal.Body>
    </Modal>

  );
};
